<template>
  <div class="home">
    <TopHeader
      ref="topHeader"
      :homeBtnHide="true"
      :LoginBtnShow="LoginBtnShow"
      :banner="banner"
      :welcome="welcome"
      :logo="logo"
      :headLogo="headLogo"
      :pageIndex="pageIndex"
      @handleLogin="handleLogin"
      @handleOrder="handleOrder"
      @registShowEvent="registShowEvent"
      @loginOk="loginOk"
      @loginOut="loginOut"
    ></TopHeader>
    <div v-if="form.isOpenAd==='T'">
      <div class="w1280 overflow abs">
        <div class="marquee-box">
          <div class="marquee-title">
            <img src="../assets/images/home/whiteClock.png" alt />
            <span>公告</span>
          </div>
          <marquee v-if="form.isOpenAd==='T'" scrollamount="5">{{form.adContent}}</marquee>
        </div>
      </div>
    </div>

    <div class="main-box">
        <router-view @loginOut="loginOut" @pageIndexs="pageIndexEvent"></router-view>
    </div>
    <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="title">预定须知</div>
      <span class="notice panel-body" v-html="getRichContent(notice)"></span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!agree" class="cancal" :disabled="false" type="info">请仔细阅读须知（{{codeText}}S)</el-button>
        <el-checkbox
          v-else
          class="selctes"
          style="background:#241008;color:#fff;padding:12px 20px;border-radius: 4px"
          v-model="checkStatus"
          @change="handleNoticeChange"
        >我已详细阅读，继续预定</el-checkbox>
        <!-- <el-button

          @click="dialogVisible = false"

        >我已详细阅读，继续预定</el-button>-->
      </span>
    </el-dialog>
    <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogVisibleTicket"
      :close-on-click-modal="false"
    >
      <div class="title">购票须知 <i @click="dialogVisibleTicket=false" style="float: right;cursor: pointer;" class="el-icon-close"></i></div>
      <span class="notice panel-body" v-html="getRichContent(noticeTicket)"></span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancal" @click="dialogVisibleTicket=false" type="primary">我已详细阅读，继续预定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="登录提示" :visible.sync="centerDialogVisible" width="30%">
      <div class="dialog-tip">您还未登录，请用微信扫码登录</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="nanputuo-cancel" @click="centerDialogVisible = false">取 消</el-button>
        <el-button class="nanputuo-confirm" type="primary" @click="handleToLogin">去登录</el-button>
      </span>
    </el-dialog>
    <el-dialog title :visible.sync="dialogLogin" width="30%">
      <div class="dialog-login">
        <iframe id="frame" :src="iframeUrl" frameborder="0"></iframe>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogErrorVisible"
    >
      <div class="title">停用提醒</div>
      <span class="notice">{{remark||'暂无数据'}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn cancal" @click="dialogErrorVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <loginPlane
      ref="loginwrap"
      :loginShow="loginShow"
      @closeLogin="closeLogin"
      @registShowEvent="registShowEvent"
      @loginOk="loginOk"
    ></loginPlane>
    <registered
      :registShow="registShow"
      @toLogin="toLogin"
      @clsoeRegist="clsoeRegist"
      :registType="registType"
      @termsOfServiceEvent="termsOfServiceEvent"
    ></registered>
    <!-- <TermsOfService
      :termsOfServiceshow="termsOfServiceshow"
      @termsOfServiceEvent="termsOfServiceEvent"
    ></TermsOfService> -->
    <CopyRight :logo="logo"></CopyRight>
    <el-dialog
      custom-class="notice-dialog1"
      width="30%"
      :show-close="false"
      title
      :visible.sync="popupDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="title">预约须知</div>
      <span class="notice panel-body" v-html="getRichContent(popupContent)"></span>
      <span slot="footer" class="dialog-footer">
        <div class="notice-dialog1-btn" @click="popupDialogVisible=false" type="primary">同意并开始预约</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../components/TopHeader'
import CopyRight from '../components/CopyRight'
import { dateFtt } from '../common/js/common'
import { config } from '@/constant/config'
import loginPlane from './login'
import registered from './registered'
// import TermsOfService from '../components/TermsOfService'
import { getToken, sysConfig, Login } from '@/api/buyTicket'
import { loadAreaList, loadHomePopupInfo } from '@/api/home'
export default {
  components: {
    TopHeader,
    CopyRight,
    loginPlane,
    registered
  },
  data () {
    return {
      termsOfServiceshow: false,
      loginShow: false,
      registShow: false,
      registType: 0,
      currentDate: '',
      tomorrowDate: '',
      date: [],
      dateList: [],
      checkStatus: false,
      form: {},
      dialogVisible: false,
      list: [],
      allSelectNumber: 0,
      headLogo: null,
      allPrice: 0,
      pickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const bday = 2 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate + bday ||
          time.getTime() > dateRegion
        }
      },
      ordinarypickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate ||
          time.getTime() > dateRegion
        }
      },
      flag: false,
      tiketType: 'spot',
      flightLineList: [],
      tabIndex: 0,

      ReservationConfig: {},
      timeSharingIndex: null,
      selectDate: '',
      timeSharing: [],
      dateBox: [],
      valueDate: '',
      selectNum: 1,
      ticketList: [],
      customize: '',
      LoginBtnShow: false,
      centerDialogVisible: false,
      disable: false,
      iframeUrl: '',
      dialogLogin: false,
      dialogErrorVisible: false,
      remark: '',
      tableKey: 0,
      currentTab: 0,
      ordinaryValueDate: null,
      notice: '',
      isOpenNotice: false,
      codeText: 5,
      agree: false,
      banner: [],
      welcome: '',
      logo: '',
      oldticketList: null,
      timeSharingSelect: false,
      path: null,
      maxQuantit: null,
      noticeTicket: '',
      dialogVisibleTicket: false,
      pageIndex: '1',
      popupContent: '',
      popupDialogVisible: false
    }
  },
  destroyed () {
  },
  computed: {
  },
  created () {
    this.init()
    this.loadAreaList()
  },
  mounted () {
  },
  methods: {
    // 富文本处理
    getRichContent (content) {
      if (content && typeof (content) === 'string') {
        const regexPre = new RegExp('pre>', 'g')
        content = content.replace(regexPre, 'div>')
      }
      return content
    },
    // 加载地址列表
    loadAreaList () {
      loadAreaList().then(async res => {
        if (res.code === 0) {
          const areaList = await this.del(res.data)
          this.$store.dispatch('setAreaList', areaList)
        }
      })
    },
    del (arr) {
      for (let item of arr) {
        if (item.children.length === 0) {
          delete item.children
        } else if (item.children.length > 0) {
          this.del(item.children)
        }
      }
      return arr
    },
    pageIndexEvent (value) {
      this.pageIndex = value
      let path = '/'
      if (value === '2') {
        path = 'myOrder'
      }
      this.$router.push({
        path
      })
    },
    selectNumChage () {
      let allSelectNumber = 0
      let allPrice = 0
      this.ticketList.forEach(item => {
        allSelectNumber += item.selectNum
        allPrice += Number(item.salePrice) * item.selectNum
      })
      this.allSelectNumber = allSelectNumber
      this.allPrice = allPrice
    },
    ticketKindVOListShow (text) {
      text = text ? text.replace('<img class="wscnph" src="', '<img class="wscnph" src="' + config.BASE_URL + '/') : ''
      if (text) {
        const regExp = new RegExp('<img src="/file/download/', 'g')
        text = text.replace(regExp, `<img src="${config.BASE_URL}/file/download/`)
        // eslint-disable-next-line no-useless-escape
        text = text.replace(/\<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
      }
      this.noticeTicket = text
      this.dialogVisibleTicket = true
    },
    handleNoticeChange () {
      window.setTimeout(() => {
        this.dialogVisible = false
        this.checkStatus = false
      }, 500)
    },
    termsOfServiceEvent () {
      this.termsOfServiceshow = !this.termsOfServiceshow
    },
    init () {
      if (sessionStorage.getItem('token') && sessionStorage.getItem('loginState') === '1') {
        this.LoginBtnShow = true
      }
    },
    // 退出登录
    loginOut () {
      this.LoginBtnShow = false
    },
    token (orgId) {
      getToken(orgId).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('token', res.data)
          // 查询预约余票量
          // this.standByList()
          this.getReservationConfig()
          this.sysConfig(orgId)
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    handleToLogin () {
      this.centerDialogVisible = false
      const returnUrl = window.location.href
      Login(returnUrl).then(res => {
        this.dialogLogin = true
        this.iframeUrl = res
        // window.location = res
      })
    },
    handleOrder () {
      if (this.LoginBtnShow) {
        this.centerDialogVisible = true
      } else {
        console.log(123)
        // this.$router.push('/myOrder')
      }
    },
    handleLogin (path) {
      this.loginShow = true
      this.LoginBtnShow = false
      this.path = path
      this.pageIndex = '1'
    },
    loginOk () {
      this.LoginBtnShow = true
      sessionStorage.setItem('loginState', '1')
      if (this.path === '/myOrder') {
        this.$router.push('/myOrder')
      }
      this.loadHomePopupInfo()
    },
    loadHomePopupInfo () {
      const nowPath = this.$route.path
      let moduleType = 'TRIP'
      if (nowPath.indexOf('hote') !== -1) {
        moduleType = 'HOTEL'
      } else if (nowPath.indexOf('food') !== -1) {
        moduleType = 'FOOD'
      } else if (nowPath.indexOf('retail') !== -1 || nowPath === '/cart') {
        moduleType = 'RETAIL'
      }
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        moduleType
      }
      loadHomePopupInfo(data).then(res => {
        if (res.code === 0) {
          if (res.data) {
            const index = res.data.typeList.findIndex(val => val === 'website')
            if (index > -1) {
              this.popupDialogVisible = true
              this.popupContent = res.data.content
            }
          }
        }
      })
    },
    closeLogin () {
      this.loginShow = false
    },
    clsoeRegist () {
      this.registShow = false
    },
    // closeStatement(){
    //   this.statementShow = !this.statementShow
    // },
    registShowEvent (i) {
      this.registType = i
      this.loginShow = false
      this.registShow = true
    },
    toLogin () {
      this.registShow = false
      this.loginShow = true
    },
    getSelectTime () {
      this.date.forEach(item => {
        if (item.isCheck) {
          this.selectTime = item.selectTime || {}
          this.selectTime.showDate = item.showDate
        }
      })
    },
    handleQuantity () {
      this.list = [...this.list]
    },
    selectToday () {
      this.currentDate = dateFtt('yyyy-MM-dd', new Date())
      this.date = this.currentDate
      if (this.tiketType === 'spot') {
        this.initQuantity()
      } else {
        this.getFerryList()
      }
    },
    sysConfig (orgId, showNotice) {
      this.form = {}
      const data = {
        typeCode: 'PC',
        orgId: orgId
      }
      sysConfig(data).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.welcome = res.data.welcomeWords
            this.logo = config.BASE_URL + res.data.banneLogorUrl
            const imgList = res.data.bannerUrl.split(',')
            imgList.forEach(item => {
              this.banner.push(config.BASE_URL + item)
            })
            document.title = res.data.mallName
            res.data.notice = res.data.notice ? res.data.notice.replace('<img class="wscnph" src="', '<img class="wscnph" src="' + config.BASE_URL + '/') : ''
            if (res.data.notice) {
              const regExp = new RegExp('<img src="/file/download/', 'g')
              res.data.notice = res.data.notice.replace(regExp, `<img src="${config.BASE_URL}/file/download/`)
              // eslint-disable-next-line no-useless-escape
              res.data.notice = res.data.notice.replace(/\<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
            }
            this.notice = res.data.notice
            this.isOpenNotice = res.data.isOpenNotice
            if (res.data.isOpenNotice === 'T' && showNotice === true) {
              this.dialogVisible = true
              this.codeText = res.data.countDown
              this.timer = setInterval(() => {
                if (this.codeText === 0) {
                  this.agree = true
                  clearInterval(this.timer)
                }
                this.codeText--
              }, 1000)
            }
            this.form = res.data
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        }
      })
    },
    handleNotice () {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  overflow: hidden;
  min-height: 100vh;
  // background: url("../assets/images/home/bg.png")
}
.tiketType_box {
  margin-top: 20px;
  padding-bottom: 50px;
}
.abs {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.marquee-box {
  height: 58px;
  background: #9B232A;
  opacity: 1;
  margin-top: 24px;
  border-radius: 45px;
  padding-left: 24px;
}
.marquee-title {
  float: left;
  width: 58px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #F9FAFA;
  font-size: 14px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 76px);
  display: block;
  line-height: 58px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #F9FAFA;
  height: 58px;
  font-size: 14px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .tab {
    overflow: hidden;
    span {
      float: left;
      width: 130px;
      height: 100%;
      line-height: 44px;
      border-radius: 6px;
      overflow: hidden;
      font-style: normal;
      font-size: 14px;
      background: #fff;
      text-align: center;
      cursor: pointer;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-right: 10px;
      &.active {
        background: #241008;
        color: #fff;
      }
    }
  }
  .pane {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 19px;
        .title {
          display: flex;
          font-size: 16px;
          color: #2D3E54;
          font-weight: bold;
          line-height: 26px;
          height: 46px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
          }
        }
        .buyticket-right {
          overflow: hidden;
          .select-list {
            .noMR {
              margin-right: 0 !important;
            }
            > span {
              display: inline-block;
              width: 203px;
              min-height: 44px;
              border-radius: 6px;
              font-size: 16px;
              color: #424855;
              text-align: center;
              line-height: 22px;
              cursor: pointer;
              margin-bottom: 10px;
              margin-right: 83px;
              > span {
                &.disable {
                  color: #cdcdcd;
                  cursor: no-drop;
                }
              }
              > em {
                position: relative;
                display: inline-block;
                width: 203px;
                height: 30px;
                line-height: 30px;
                border-radius: 4px;
                overflow: hidden;
                font-style: normal;
                background: white;
                border: 1px solid #A7AEBB;
                padding: 6px 0;
                > img {
                  position: absolute;
                  bottom: -1px;
                  right: -1px;
                }
                &:hover {
                  opacity: 0.8;
                }
                &.active {
                  background: white;
                  border: 1px solid #3987E1;
                  color: #1E2431;
                }
                &.disable {
                  color: #cdcdcd;
                  cursor: no-drop;
                }
              }
            }
          }
          .time-select-text {
            line-height: 44px;
            color: #ec2f2f;
          }
          .select-btn {
            float: right;
            width: 203px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
          .buyticket-list {
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
}
.notice-dialog {
  .selctes /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fff;
  }
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    // min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
    line-height: 20px;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
.payBtn {
  display: inline-block;
  width: 80px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  background: #3987E1;
  color: #fff;
  cursor: pointer;
  &.disable {
    background: #f6f6f6;
    cursor: no-drop;
    color: #cdcdcd;
  }
  &:hover {
    opacity: 0.8;
  }
}
.tips {
  position: fixed;
  top: 22%;
  right: 0;
}
.buyticket-hint {
  display: flex;
  align-items: center;
  img {
    margin-right: 9px;
  }
}
</style>
